module.exports = __webpack_public_path__ + "img/yishi13.c5580687.jpg";